export default __webpack_public_path__ + "static/media/kitchen5-beforeB-2048w.0876ff84.avif";